import get from 'lodash/get'

export const ACCOUNT_BALANCE = 'accountBalance'
export const LOOKBUILDER_PDP_ENTRYPOINT = 'lookbuilderPdpEntrypoint'
export const RENTAL_PAGE_HERO_CTA = 'rentalPageHeroCta'
export const STYLED_LOOKS_ONBOARDING = 'styledLooksOnboarding'
export const BUY_PATH = 'buyPathVariant'

// Get
export const getTestVariant = (test) => (state) => get(state, `ab.${test}`)
export const isAccountBalanceActive = (state) => get(state, `ab.${ACCOUNT_BALANCE}`) === 1
export const isLookbuilderPdpEntrypointActive = (state) =>
  get(state, `ab.${LOOKBUILDER_PDP_ENTRYPOINT}`) === 1
export const isRentalPageHeroCtaActive = (state) => get(state, `ab.${RENTAL_PAGE_HERO_CTA}`) === 1

// Computed

export const isVariationActive = (state, {test, variation}) =>
  variation
    ? getTestVariant(test)(state) === variation // if a variation is specified, it must match the store
    : !getTestVariant(test)(state) // if a variation is NOT specified, the store must be falsy, i.e. original variation
